import { Button, Flex } from "@mantine/core";
import { modals } from "@mantine/modals";
import { showNotification } from "@mantine/notifications";
import axios from "axios";
import { useState } from "react";
import { API_URL } from "../../services/url";

type Props = {
  jobId: string | null;
  responsibledriver: string | null;
  onRefetch: () => void;
};

export const ReturnJob: React.FC<Props> = ({ responsibledriver, jobId, onRefetch }) => {
  const urlParams = new URLSearchParams(window.location.search);

  const [loading, setLoading] = useState(false);

  const userId = localStorage.getItem("userId");

  const handleReturn = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${API_URL}jobs/${jobId}/cancel/${userId}`);
      if (res.data) {
        console.log("🚀 ~ handleReturn ~ res", res.data);
        onRefetch();
      }
    } catch (error) {
      showNotification({
        title: "Error",
        message: "Failed To Return Job",
        color: "red",
      });
    } finally {
      setLoading(false);
    }
    onRefetch();
  };

  const handleReAssign = async () => {
    try {
      setLoading(true);
      const response = await axios.post(`${API_URL}assignjob-driverid/`, {
        job_id: jobId,
        driver_id: responsibledriver
      });
      if (response.data.message.includes('successfully')) {
        showNotification({
          title: "Success",
          message: "Job requested successfully",
          color: "green",
        });
        setLoading(false);
        onRefetch();
      }
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ handleReAssign ~ error:", error);
    }
  }

  // return job modal
  const returnConfirmationModal = () =>
    modals.openConfirmModal({
      title: "Are you sure want to return the job?",
      centered: true,
      // children: <Text size="sm">Are you sure want to Cancel your job?</Text>,
      labels: {
        confirm: "Yes, Return",
        cancel: "No",
      },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => {
        responsibledriver !== null && userId !== responsibledriver ? handleReAssign() : handleReturn();
      },
      confirmProps: { color: "red" },
    });

  return (
    <Flex justify={"center"}>
      <Button
        w={"90%"}
        radius={"md"}
        size="md"
        color="red"
        variant="outline"
        mt={"lg"}
        disabled={loading}
        onClick={returnConfirmationModal}
        loaderProps={{ type: "oval" }}
      >
        {`Can't Full Fill Job`}
      </Button>
    </Flex>
  );
};
